<template>
    <div class="audiovisualLibrary">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >祖地文旅</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 标题 -->
            <h3 class="font-style-s">
                <img src="@/assets/imgs/yy/3@2x.png" alt="">
                祖地文旅
                <img src="@/assets/imgs/yy/4@2x.png" alt="">
            </h3>
            <!-- 内容 -->
            <ul>
                <li v-for="item in lists" :key="item.id" @click="handleDetail(item)">
                    <img :src="item.picUrl" alt="" style="object-fit: cover;">
                    <div class="texts">
                        <h5>{{item.title}}</h5>
                        <label for="">
                            {{item.year}}年{{item.month}}月{{item.day}}日
                        </label>
                        <p class="line-clamp3">{{item.introduction || '暂无描述~'}}</p>
                        <img class="more"  src="@/assets/imgs/more@3x.png" alt="">

                    </div>
                </li>
            </ul>
            <div class="fs12" v-if="!lists.length">暂无数据</div>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handlePageChange"
                :current-page="page"
                :total="total"
                :page-size="10">
            </el-pagination>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { articleLists } from '@/api/index';
import moment from 'moment';
import { useRoute, useRouter } from 'vue-router/composables';
const router = useRouter();

const lists = ref([]);
const page = ref(1);
// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: page.value,
        pageSize: 10,
        categoryId: 4
    }).then(({ data }) => {
        const _data = data?.list || [];

        _data.forEach((element) => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        lists.value = _data;
        total.value = data?.total || 0;
    });
};

const handleDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/literatureLecture/detail?id=' + item.id + '&categoryId=' + 4);

    }
};

onMounted(() => {
    getZxLists();
});

const total = ref(0);
const handlePageChange = (val) => {
    page.value = val;
    getZxLists();
};
</script>

<style lang="scss" scoped>
.container{
    padding: 30px 0;

   h3{
        font-weight:700;
        color:#555555;
        font-size:33px;
        text-align:center;
        margin-bottom: 22px;
        margin-top: 18px;
        img{
            width: 24px;
            height: 37px;
            vertical-align: middle;
        }
    }
    ul{
        li{
            display: flex;
            background: #fff;
            padding: 15px 18px;
            margin-bottom: 20px;
            cursor: pointer;

            img{
                width: 191px;
                height: 261px;
            }
            .texts{
                padding:17px 32px;
                flex: 1;
                box-sizing: border-box;
                 position: relative;
                h5{
                    color:#232323;
                    font-size:24px;
                    margin-bottom: 20px;
                }
                label{
                    color:#848484;
                    font-size:18px;
                    display: block;
                    border-bottom: 1px dotted rgba(#707070,0.4);
                }
                p{
                    color:#848484;
                    font-size:18px;
                    margin-top: 15px;
                }
                a{
                    width: 87px;
                    height: 26px;
                    border: 1px solid;
                    border-color: #686868;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
                .more{
                      width: 87px;
                    height: 26px;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
            }
        }
    }

    .pagination{
        margin: 100px auto;
        text-align: center;
    }
}
</style>
